/**
 * Copyright (c) 2021 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  clearConsentDocumentsForSoP,
  fetchConsentDocumentForSoP,
  fetchConsentingOptInState4SoP
} from '../../../actions/document.status.optinoptout.actions';
import * as actions from '../../../actions/document.status.actions';
import { hideModal, showModal } from '../../../actions/actions';
import { MODAL_TYPE_EDIT_DOCUMENT_STATUS } from '../../../constants/modalTypes';
import { CHANGE_DOCUMENT_STATUS, VERSION } from '../../../const';
import DocumentChangeStatusFillSoPOptInOptOutComponent from './document.status.optinoptout.component';

export const extractOptInsOptOuts = (consentDocumentData = {}) => {
  const hasArrayPropertyByNameFilter = (name) => (obj) =>
    R.hasIn(name, obj) && R.is(Array, obj[name]) && obj[name].length > 0;
  const extractFieldMap = (name) => (obj) => obj[name];
  const isCheckboxOrRadioOptInOptOutFilter = R.anyPass([
    R.propEq('type', 'input-checkbox'),
    R.propEq('type', 'input-radio')
  ]);

  return (R.path(['data', 'consent', 'content', 'sections'], consentDocumentData) || [])
    .filter(hasArrayPropertyByNameFilter('pages'))
    .flatMap(extractFieldMap('pages'))
    .filter(hasArrayPropertyByNameFilter('fragments'))
    .flatMap(extractFieldMap('fragments'))
    .filter(hasArrayPropertyByNameFilter('fields'))
    .flatMap(extractFieldMap('fields'))
    .filter(R.allPass([isCheckboxOrRadioOptInOptOutFilter, hasArrayPropertyByNameFilter('options')]))
    .map(({ type, options = [] }) => ({
      type,
      options: options.map(({ id, text, sponsor }) => ({ id, text, sponsor }))
    }));
};

export const extractOptInChoiceAnswers = (choiceAnswers = []) =>
  choiceAnswers.filter((item) => item.choiceAnswerType === 'YES').map((item1) => item1.questionId);

export const mapStateToProps = (state) => {
  const {
    isFetching,
    consentDocumentData,
    consentingOptInState,
    error: errorDocumentStatusSoP
  } = state.documentStatusSoP;
  return {
    isLoading: isFetching,
    listOfOptInOptOut: extractOptInsOptOuts(consentDocumentData),
    consentingOptInState: consentingOptInState && extractOptInChoiceAnswers(consentingOptInState),
    error: state.documentStatus.error || errorDocumentStatusSoP,

    studyGid: state.subject.participantJourney.studyGid,
    participantId: state.subject.participantJourney.userId
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    loadDocumentOptInsOutsWithState: (consentGid, consentingGid) => {
      dispatch(fetchConsentingOptInState4SoP(consentingGid));
      dispatch(fetchConsentDocumentForSoP(consentGid));
    },
    next: (props) => {
      const { consentingGid, studyGid, participantId, status, statusDate, reason, choiceAnswers } = props;
      const payload = { documentId: consentingGid, studyGid, participantId, status, statusDate, reason, choiceAnswers };

      dispatch(actions.saveStatus(payload, true));
    },
    cancel: () => {
      dispatch(clearConsentDocumentsForSoP());
      dispatch(hideModal());
    },
    previous: (props) => {
      const { consentName, consentVersion } = props;

      dispatch(
        showModal(MODAL_TYPE_EDIT_DOCUMENT_STATUS, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_DOCUMENT_STATUS,
          details: [consentName, '-', VERSION, consentVersion].join(' '),
          className: 'document-status-modal',
          props: props
        })
      );
    }
  };
};

export const CDocumentChangeStatusFillSoPOptInOptOut = connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentChangeStatusFillSoPOptInOptOutComponent);
